import { css, html } from 'react-strict-dom';

import { Text } from '../../../components';
import { color } from '../../../constants/color.css';
import { COLUMNS, type WishlistColumn } from '../board';

type Props = {
  selected: WishlistColumn;
  onSelect: (column: WishlistColumn) => void;
};

export default function ColumnSwitcher({ selected, onSelect }: Props) {
  return (
    <html.div style={styles.row}>
      {COLUMNS.map((column) => {
        const active = column.key === selected;
        return (
          <html.button
            key={column.key}
            style={[styles.chip, active ? styles.chipActive : styles.chipIdle]}
            onClick={() => onSelect(column.key)}
          >
            <Text
              typeface="body.small.medium"
              color={active ? 'neutral0' : 'neutral70'}
            >
              {column.label}
            </Text>
          </html.button>
        );
      })}
    </html.div>
  );
}

const styles = css.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
  },
  chip: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingInline: 8,
    paddingBlock: 8,
    borderWidth: 0,
    borderRadius: 8,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  chipActive: {
    backgroundColor: color.neutral100,
  },
  chipIdle: {
    backgroundColor: color.neutral10,
  },
});
